export default x => () => x;



//////////////////
// WEBPACK FOOTER
// ./~/d3-drag/src/constant.js
// module id = 462
// module chunks = 0